require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-valuable-tips-for-purchasing-off-the-plan.json") })
        }
      }, "path---news-valuable-tips-for-purchasing-off-the-plan");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-valuable-tips-for-purchasing-off-the-plan!./.cache/json/news-valuable-tips-for-purchasing-off-the-plan.json
// module id = 860
// module chunks = 231608221292675